import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import styles from './DiscardContractDialog.style';

const DiscardContractDialog = ({
  onDismiss,
  onSubmit,
  isOnboardedContract,
  isDiscarding,
  discardError,
  ...other
}) => {
  const subText = isOnboardedContract
    ? 'Discarding the draft contract will remove this contract.'
    : 'Discarding the draft contract will remove the edits made to this contract.';

  const title = isOnboardedContract ? 'contract' : 'edits';
  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title: `Discard ${title}?`,
        closeButtonAriaLabel: 'Close',
        subText: `${subText} Do you wish to continue?`,
      }}
      onDismiss={onDismiss}
      {...other}
    >
      {discardError && (
        <Label className={styles.textColorError}>
          An error occurred while discarding the contract, please try again.
        </Label>
      )}

      <DialogFooter>
        <DefaultButton onClick={onDismiss} data-testid="cancelModalButton">
          Cancel
        </DefaultButton>
        <PrimaryButton data-testid="discardDraftModalButton" onClick={onSubmit}>
          Discard
          {isDiscarding && (
            <Spinner
              data-testid="discard-draft-spinner"
              size={SpinnerSize.medium}
              className={styles.discardContractDialogSpinner}
            />
          )}
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};

DiscardContractDialog.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOnboardedContract: PropTypes.bool,
  isDiscarding: PropTypes.bool,
  discardError: PropTypes.object,
};

DiscardContractDialog.defaultProps = {
  isOnboardedContract: false,
  isDiscarding: false,
  discardError: null,
};

export default DiscardContractDialog;
